






import Vue from 'vue';
import AppModule from '../../common/components/AppModule.vue';
import {AppModuleConfig, AppModuleNavItem} from '../../common/models/AppModuleConfig';

const moduleNavs: AppModuleNavItem[] = [];

const module: AppModuleConfig = {
  module: 'upgrade',
  name: '会员升级',
  navs: moduleNavs,
  description: '服务购买前请查看会员包含的具体服务内容。',
};

export default Vue.extend({
  components: {
    AppModule,
  },
  data() {
    return {
      module,
    };
  },
});
